// extracted by mini-css-extract-plugin
export var card = "styles-module--card--0aea0";
export var cardImage = "styles-module--cardImage--3ce78";
export var cardLink = "styles-module--cardLink--85cdf";